
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.375 4a.625.625 0 011.25 0v5c0 .345-.28.625-.625.625H4.51l1.933 1.933.08.098a.626.626 0 01-.866.867l-.099-.08-3-3a.626.626 0 010-.885l3-3a.626.626 0 01.885.884L4.51 8.375h6.865V4z","fill":"#FDFDFD"}})])
          )
        }
      }
    